// Colombo
import colombo from 'src/assets/img/destination/colombo/colombo.jpg';
import colomboBg from 'src/assets/img/destination/colombo/bg.jpg';
import colomboX from 'src/assets/img/destination/colombo/colomboX.jpg';
import Maniumpathy from 'src/assets/img/destination/colombo/Maniumpathy.jpg';
import MarinoBeachColombo from 'src/assets/img/destination/colombo/MarinoBeachColombo.jpg';
import ResidenceByUgaEscapes from 'src/assets/img/destination/colombo/ResidenceByUgaEscapes.jpg';
import ParadiseRoadTintagelColombo from 'src/assets/img/destination/colombo/ParadiseRoadTintagelColombo.jpg';
import JetwingColomboSeven from 'src/assets/img/destination/colombo/JetwingColomboSeven.jpg';
import CinnamonRedColombo from 'src/assets/img/destination/colombo/CinnamonRedColombo.jpg';

// Sigiriya
import sigiriya from 'src/assets/img/destination/sigiriya.jpg';
import sigiriyaBg from 'src/assets/img/destination/sigiriya/bg.jpg';
import aliyaresortandspa from 'src/assets/img/destination/sigiriya/aliyaresortandspa.jpg';
import camelliaresort from 'src/assets/img/destination/sigiriya/camelliaresort.jpg';
import hotelsigiriya from 'src/assets/img/destination/sigiriya/hotelsigiriya.jpg';
import hotelwewaaddara from 'src/assets/img/destination/sigiriya/hotelwewaaddara.jpg';
import KassapaLionsRock from 'src/assets/img/destination/sigiriya/KassapaLionsRock.jpg';
import sigiriyajungles from 'src/assets/img/destination/sigiriya/sigiriyajungles.jpg';

// Ella
import ellaImage from 'src/assets/img/destination/Elladesti.jpg';
import ellaBg from 'src/assets/img/destination/ella/ellaBg.jpg';
import AcresResortandSpa from 'src/assets/img/destination/ella/AcresResortandSpa.jpg';
import ChamodyaHomeStay from 'src/assets/img/destination/ella/ChamodyaHomeStay.jpg';
import EllFlowerGardenResort from 'src/assets/img/destination/ella/EllFlowerGardenResort.jpg';
import HotelOnrock from 'src/assets/img/destination/ella/HotelOnrock.jpg';
import LakshmisHotel from 'src/assets/img/destination/ella/LakshmisHotel.jpg';
import TheSecretElla from 'src/assets/img/destination/ella/TheSecretElla.jpg';

// Kandy
import kandy from 'src/assets/img/destination/kandy.jpg';
import kandyBg from 'src/assets/img/destination/kandy/bg.jpg';
import kandyBg1 from 'src/assets/img/destination/kandy/bg1.jpg';
import AmaaraSkyHotelKandy from 'src/assets/img/destination/kandy/AmaaraSkyHotelKandy.jpg';
import CinnamonCitadelKandy from 'src/assets/img/destination/kandy/CinnamonCitadelKandy.jpg';
import HotelSuisse from 'src/assets/img/destination/kandy/HotelSuisse.jpg';
import MahaweliReachHotel from 'src/assets/img/destination/kandy/MahaweliReachHotel.jpg';
import RandholeeResortAndSpa from 'src/assets/img/destination/kandy/RandholeeResortAndSpa.jpg';
import TheGrandKandyanHotel from 'src/assets/img/destination/kandy/TheGrandKandyanHotel.jpg';

// Anuradhapura
import anuradhapura from 'src/assets/img/destination/anuradhapura.jpg';
import anuradhapuraBg from 'src/assets/img/destination/anuradhapura/bg.jpg';
import aryanahotel from 'src/assets/img/destination/anuradhapura/aryanahotel.jpg';
import avasta from 'src/assets/img/destination/anuradhapura/avasta.jpg';
import forestrockgardenresort from 'src/assets/img/destination/anuradhapura/forestrockgardenresort.jpg';
import heritagehotel from 'src/assets/img/destination/anuradhapura/heritagehotel.jpg';
import randiya from 'src/assets/img/destination/anuradhapura/randiya.jpg';
import whitehouse from 'src/assets/img/destination/anuradhapura/whitehouse.jpg';

// Jaffna
import jaffna from 'src/assets/img/destination/jaffna.jpg';
import bg from 'src/assets/img/destination/jaffna/bg.jpg';
import jaffnadesti from 'src/assets/img/destination/jaffna/jaffnadesti.jpg';
import FoxResortsJaffna from 'src/assets/img/destination/jaffna/FoxResortsJaffna.jpg';
import JetwingJaffna from 'src/assets/img/destination/jaffna/JetwingJaffna.jpg';
import MargosaGreen from 'src/assets/img/destination/jaffna/MargosaGreen.jpg';
import NorthGatebyJetwing from 'src/assets/img/destination/jaffna/NorthGatebyJetwing.jpg';
import TheThinnai from 'src/assets/img/destination/jaffna/TheThinnai.jpg';
import TilkoJaffnaCityHotel from 'src/assets/img/destination/jaffna/TilkoJaffnaCityHotel.jpg';

// Dambulla
import dambulla from 'src/assets/img/destination/dambulla.jpg';
import dambulladesti from 'src/assets/img/destination/dambulla/dambulladesti.jpg';
import DambullaRockArch from 'src/assets/img/destination/dambulla/DambullaRockArch.jpg';
import DignityVilla from 'src/assets/img/destination/dambulla/DignityVilla.jpg';
import FlamboyantVillas from 'src/assets/img/destination/dambulla/FlamboyantVillas.jpg';
import SunAndGreenEcoLodge from 'src/assets/img/destination/dambulla/SunAndGreenEcoLodge.jpg';
import TheGreenEdge from 'src/assets/img/destination/dambulla/TheGreenEdge.jpg';
import VihangaVillage from 'src/assets/img/destination/dambulla/VihangaVillage.jpg';

// Polonnaruwa
import polonnaruwa from 'src/assets/img/destination/polonnaruwa/polonnaruwa.jpg';
import polonnaruwaBg from 'src/assets/img/destination/polonnaruwa/bg.jpg';
import DeerParkHotel from 'src/assets/img/destination/polonnaruwa/DeerParkHotel.jpg';
import GiritaleHotel from 'src/assets/img/destination/polonnaruwa/GiritaleHotel.jpg';
import HotelSuduarAliya from 'src/assets/img/destination/polonnaruwa/HotelSuduarAliya.jpg';
import PharoLake from 'src/assets/img/destination/polonnaruwa/PharoLake.jpg';
import RuinsChaaa from 'src/assets/img/destination/polonnaruwa/RuinsChaaa.jpg';
import TheLakePanoramaHolidayVilla from 'src/assets/img/destination/polonnaruwa/TheLakePanoramaHolidayVilla.jpg';

// Trincomalee
import trincomalee from 'src/assets/img/destination/trincomalee/trincomalee.jpg';
import trincomaleeBg from 'src/assets/img/destination/trincomalee/bg.jpg';
import trincomaleeBg3 from 'src/assets/img/destination/trincomalee/bg3.jpg';
import AlfrescoBeachHotel from 'src/assets/img/destination/trincomalee/AlfrescoBeachHotel.jpg';
import AmarantheBayResort from 'src/assets/img/destination/trincomalee/AmarantheBayResort.jpg';
import JungleBayResort from 'src/assets/img/destination/trincomalee/JungleBayResort.jpg';
import SeaLotusParkHotel from 'src/assets/img/destination/trincomalee/SeaLotusParkHotel.jpg';
import SkandigBeachResort from 'src/assets/img/destination/trincomalee/SkandigBeachResort.jpg';
import TrincoBlubyCinnamon from 'src/assets/img/destination/trincomalee/TrincoBlubyCinnamon.jpg';

// Nuwara Eliya
import nuwaraeliya from 'src/assets/img/destination/nuwaraeliya/nuwaraeliya.jpg';
import nuwaraeliyaBg from 'src/assets/img/destination/nuwaraeliya/bg.jpg';
import nuwaraeliyaHero from 'src/assets/img/destination/nuwaraeliya/nuwaraeliyaHero.jpg';
import AmayaLangdale from 'src/assets/img/destination/nuwaraeliya/AmayaLangdale.jpg';
import AraliyaGreenHillsHotel from 'src/assets/img/destination/nuwaraeliya/AraliyaGreenHillsHotel.jpg';
import HeritanceTeaFactory from 'src/assets/img/destination/nuwaraeliya/HeritanceTeaFactory.jpg';
import HillPrideCityHotel from 'src/assets/img/destination/nuwaraeliya/HillPrideCityHotel.jpg';

// Yaala
import yala from 'src/assets/img/destination/yala/yala.jpg';
import yalaBg from 'src/assets/img/destination/yala/bg.jpg';
import yalaHero from 'src/assets/img/destination/yala/yalaHero.jpg';
import ElephantLakeYala from 'src/assets/img/destination/yala/ElephantLakeYala.jpg';
import JetwingYala from 'src/assets/img/destination/yala/JetwingYala.jpg';
import LayaSafari from 'src/assets/img/destination/yala/LayaSafari.jpg';
import PardusSeekLuxuryTents from 'src/assets/img/destination/yala/PardusSeekLuxuryTents.jpg';
import YalaLeopardLodge from 'src/assets/img/destination/yala/YalaLeopardLodge.jpg';
import YalaWildCorridorCamp from 'src/assets/img/destination/yala/YalaWildCorridorCamp.jpg';

// Tangalle
import tangalle from 'src/assets/img/destination/tangalle/tangalle.jpg';
import tangalleBg from 'src/assets/img/destination/tangalle/bg.jpg';
import tangalleHero from 'src/assets/img/destination/tangalle/hero.jpg';
import AnodawaBoutiqueVilla from 'src/assets/img/destination/tangalle/AnodawaBoutiqueVilla.jpg';
import AnanyaBeachResort from 'src/assets/img/destination/tangalle/AnanyaBeachResort.jpg';
import BuckinghamPlace from 'src/assets/img/destination/tangalle/BuckinghamPlace.jpg';
import CocoTangalla from 'src/assets/img/destination/tangalle/CocoTangalla.jpg';
import GreenParrotHotel from 'src/assets/img/destination/tangalle/GreenParrotHotel.jpg';
import ShangriLasHambantota from 'src/assets/img/destination/tangalle/ShangriLasHambantota.jpg';

//Galle
import galle from 'src/assets/img/destination/galle/galle.jpg';
import galleBg from 'src/assets/img/destination/galle/bg.jpg';
import galleHero from 'src/assets/img/destination/galle/Galledesti.jpg';
import EraBeach from 'src/assets/img/destination/galle/EraBeach.jpg';
import GingangaLodge from 'src/assets/img/destination/galle/GingangaLodge.jpg';
import LadyHill from 'src/assets/img/destination/galle/LadyHill.jpg';
import LeGrandGalle from 'src/assets/img/destination/galle/LeGrandGalle.jpg';
import NiyagamaHouse from 'src/assets/img/destination/galle/NiyagamaHouse.jpg';
import TheHeritageGalleFort from 'src/assets/img/destination/galle/TheHeritageGalleFort.jpg';

// Bentota
import bentota from 'src/assets/img/destination/bentota/bentota.jpg';
import bentotaHero from 'src/assets/img/destination/bentota/hero.jpg';
import bg2 from 'src/assets/img/destination/bentota/bg2.jpg';
import AvaniBentotaResort from 'src/assets/img/destination/bentota/AvaniBentotaResort.jpg';
import NisalaAranaBoutiqueHotel from 'src/assets/img/destination/bentota/NisalaAranaBoutiqueHotel.jpg';
import SamanVillas from 'src/assets/img/destination/bentota/SamanVillas.jpg';
import SriVillas from 'src/assets/img/destination/bentota/SriVillas.jpg';
import TajBentotaResortAndSpa from 'src/assets/img/destination/bentota/TajBentotaResortAndSpa.jpg';
import TaruVillasRockVilla from 'src/assets/img/destination/bentota/TaruVillasRockVilla.jpg';

// Negambo
import negambo from 'src/assets/img/destination/negambo/negambo.jpg';
import negamboBg from 'src/assets/img/destination/negambo/bg.jpg';
import negamboHero from 'src/assets/img/destination/negambo/Privercy.jpg';
import CamelotBeachHotel from 'src/assets/img/destination/negambo/CamelotBeachHotel.jpg';
import JetwingLagoon from 'src/assets/img/destination/negambo/JetwingLagoon.jpg';
import TerraceGreenHotelAndSpa from 'src/assets/img/destination/negambo/TerraceGreenHotelAndSpa.jpg';
import TranquilNegomboBoutique from 'src/assets/img/destination/negambo/TranquilNegomboBoutique.jpg';
import VillaHundira from 'src/assets/img/destination/negambo/VillaHundira.jpg';
import HeritanceNegombo from 'src/assets/img/destination/negambo/HeritanceNegombo.jpg';

export const places = [
  {
    id: 1,
    city: 'Colombo',
    country: 'Sri Lanka',
    image: colombo,
    rating: 4.5,
    heroImage: colomboX,
    backgroundImage: colomboBg,
    hotels: [
      {
        name: 'Maniumpathy',
        image: Maniumpathy,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Marino Beach Colombo',
        image: MarinoBeachColombo,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Residence By UgaEscapes',
        image: ResidenceByUgaEscapes,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Paradise Road Tintagel Colombo',
        image: ParadiseRoadTintagelColombo,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Jetwing Colombo Seven',
        image: JetwingColomboSeven,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Jetwing Colombo Seven',
        image: CinnamonRedColombo,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
    ],
    description: `Sri Lanka’s bustling commercial capital Colombo is the country’s
      busy business hub. Historically known as the garden city of the
      East Colombo sits about an hour’s drive south of the Katunayake
      International Airport Colombo and holds a variety of activities
      for the urban visitor. Busy daytime traffic, high rise buildings,
      commercial centres and modern infrastructure found in the heart of
      the city has made Colombo not much different from any other
      developed city in South East Asia, however still retaining its
      character and authentic nature. The other unique aspect of Colombo
      is that it surprisingly has lots of greenery left within the city
      and the suburbs than in other similar cities in the region.
     
      The natural sea port in Colombo has been used in international
      trade from as far as the 5th Century. Chinese, Roman and Arab
      trades have been involved in trade through the Colombo harbour
      since the very early days and the Arabs have settled in the area
      during the 8th century and have become the middle men in trade
      between the international trades and the Sri Lankan Kingdoms in
      the interior of the island. However, Colombo received much more
      prominence after the arrival of the sea traders from the west.
      Portuguese arrived in Colombo in 1505 and gradually took control
      of Colombo and the trade done through its harbour. In 1659 the
      Dutch defeated the Portuguese and took over Colombo but in 1796
      they had to surrender their trade autonomy to the British who
      arrived and took over full control of all coastal areas of Sri
      Lanka controlled by the Dutch.
     
      At present, Colombo is famous for its world class five star
      hotels, restaurants and shopping arcades. Almost all visitors to
      Sri Lanka spend at least a night or two in this busy city either
      at the beginning or the end of the tour in Sri Lanka. However, you
      find many business travellers from all around the globe spending
      lengthy periods in Colombo on corporate visits. The accommodation
      in Colombo is mainly the classy 5 star hotels and the luxury
      boutique hotels, the few mid range hotels in the city and the
      suburbs too offer good value for money. However, the lacking point
      is basic budget accommodation that is clean and reliable. Several
      nice budget places are found in Mount Lavinia and few other places
      but it is always best to use the known hotels during a short stay
      in Colombo.
  
      Colombo has much to offer and fascinate any visitor with its mix
      of influences from the colonial period, variety of food and
      restaurants, religious places, architecture, spas, monuments,
      museums, night life, sopping, beaches, classy hotels and much
      more. Visitors could still see remaining building from the
      colonial period, some more than 250 years old. The Dutch Church of
      Wolfendhaal dating back to 1749, Galle Face Hotel, Grand Oriental
      Hotel, The famous Cargills & Millers building, Old Dutch Hospital
      and several other buildings are still to be seen in a well
      preserved condition in the Fort and Pettah areas, which were the
      main administrative and commercial areas during the colonial
      period. Many other mansions of former British officials are also
      seen in the heart of Colombo, not to forget Mt. Lavinia Hotel just
      a few kilometres south of Colombo, another famous British period
      building.
      
      Visitors both local and foreign enjoy a visit to the Galle Face
      Green bordering the sea, adjacent to the historic Galle Face
      Hotel. Especially in the evenings and weekends this promenade is
      full of happy people, families with children from many different
      places of the country, kite fliers, food shops, vendors, lovers,
      children playing sport and much more.
     
      The Pettah Bazaar and Sea Street, the Goldsmith’s quarters are
      also nice places to visit and experience the busiest areas of the
      city.
      
      The Buddhist Temple in Kelaniya dating back to the 6th century,
      Gangarama Temple in Slave Island with the Seemamalaka Meditation
      Island in the Beira Lake in front, Gothami Temple in Borella with
      splendid paintings, St. Pauls Church in Milagiriya one of the
      oldest churches in Colombo, The Mosque in Devatagaha, Murugan
      Hindu Temple in Slave Island along with other Hindu Temples in
      Wellawatta area are some important religious buildings in and
      around Colombo. These buildings represent the multi religious and
      multi cultural mixed society in Colombo and are visited by many,
      from various parts of the world. The replica of the famous Aukana
      Buddha Statue in Borella and the Bandaranayake International
      Convention Center (BMICH) in front it are also considered as
      landmarks in Colombo.
    
      There are three museums in Colombo, namely The National Museum of
      Colombo and The Natural History Museum, both located in Colombo 7,
      and the Dutch Period Museum located in Pettah. Visiting the Zoo in
      Dehiwala, playing golf at the Royal Colombo Golf Club or bird
      watching at the bird sanctuaries in the nearby suburbs of
      Thalangama and Attidiya are activities that could be considered by
      visitors opting to stay longer in Colombo.`,
  },
  {
    id: 2,
    city: 'Dambulla',
    country: 'Sri Lanka',
    image: dambulla,
    rating: 4.5,
    heroImage: dambulladesti,
    backgroundImage: dambulladesti,
    hotels: [
      {
        name: 'Dambulla RockArch',
        image: DambullaRockArch,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Dignity Villa',
        image: DignityVilla,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Flamboyant Villas',
        image: FlamboyantVillas,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Sun And Green Eco Lodge',
        image: SunAndGreenEcoLodge,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'The Green Edge',
        image: TheGreenEdge,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Vihanga Village',
        image: VihangaVillage,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
    ],
    description: `
    The Dambulla Cave Temple or the Golden Caves of Infinite Buddhas is another UNESCO World Heritage Site located 148km from Colombo, approximately a 4.5 hours drive. It is an isolated rock mass, 500 feet in height with a history dating back to the 3rd Century BC when it was a meditation center where Bhikkus lived in caves. There are 35 such caves still to be seen with some having inscriptions written 2300 years ago.
    The magnificent Rock Temple was built during the 1st Century BC by King Valagamba during the Anuradhapura period. In 103 BC King Valagamba seeks refuge here and lived in exile for 14 years once he lost his Kingdom to the South Indian invaders. After he defeated the enemy and regained the Throne in 89 BC, King Valagamba converted 3 of the caves in to magnificent shrines with many splendid statues and painting as attested by the 1st Century BC Brahmi inscription of Cave No: 2. At present there are five such caves with hundreds of Buddha statues and beautiful paintings drawn on the uneven surface of the caves, done and renovated by many Kings and elite during various periods of the history after initially created by King Valagamba.
    During the 12th Century AD King Nissankamalla of Polonnaruwa renovated the caves, painted the statues in gold and re-named the place as the Golden Cave Temple in Dambulla. This is written in a well preserved large stone inscription done in the 12th Century AD by King Nissankamalla. `,
  },
  {
    id: 3,
    city: 'Sigiriya',
    country: 'Sri Lanka',
    image: sigiriya,
    rating: 4.5,
    heroImage: sigiriyaBg,
    backgroundImage: sigiriyaBg,
    hotels: [
      {
        name: 'Aliya Resort And Spa',
        image: aliyaresortandspa,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Camellia Resort',
        image: camelliaresort,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Hotel Sigiriya',
        image: hotelsigiriya,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Hotel Wewa Addara',
        image: hotelwewaaddara,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Kassapa Lions Rock',
        image: KassapaLionsRock,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Sigiriya Jungles',
        image: sigiriyajungles,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
    ],
    description: `The rock fortress of the mighty King Kasyapa who created both legend and lore with the help of this mighty citadel. Inside is a world of elaborate constructions, beautiful frescos and countless stories of the God King, his people and his City in the Sky.Sigiriya is a UNESCO World Heritage Site located approximately 170km away from Colombo. This 5th Century “Fortress in the Sky” which is perhaps the most fantastic single wonder of the island is considered as the 8th wonder of the world by many, for various reasons. It is also known as Lion Rock because of the huge lion that used to stand at the entrance to the Palace at the summit of the 600-foot high rock.This spectacular rock fortress was built in the 5th century AD by King Kassapa as his well protected castle complex after killing his father, King Datusena and taking over the throne. He built 3 moats and 3 ramparts around the fortress (still to be seen) to protect the castle, fearing his half-brother Prince Moggallana the actual heir to the throne will return from exile with an army to claim his rightful throne.At the foot of the rock on the west side of the fortress is the Pleasure Gardens, which could be enjoyed even by visitors unable to climb up the rock. The Gardens consist of the miniature water garden, the main bathing ponds with pavilions, the summerhouses, the fountain garden, and the boulder gardens including the caves. The large number of boulders on both sides of the staircase was utilized for building guardhouses that stopped any enemy trying to go up evading the steps. The famous paintings, commonly known as Sigiriya Frescos are considered the most beautiful paintings in Sri Lanka and still after 15 centuries the colours are bright and shining like recently drawn paintings. The 20 paintings still to be seen today are the figures of beautiful ladies carrying flowers in their hands or in flower baskets, bedecked with jewellery and with transparent clothing for the upper part of the body. It is believed that more than 500 paintings of similar ladies were originally drawn covering a large area of the west side of the rock, creating the largest ever mural attempted by mankind. Another wonderful creation in Sigiriya is the Mirror Wall. More than 1300 verses written on a polished surface by the visitors to Sigiriya are still to be seen unharmed. This graffiti dates from the 5th – 13th Century, where the visitors to Sigiriya have recorded their experiences and thoughts inspired by seeing the beautiful ladies of the Sigiriya Frescos. The remains of the front paws of a crouching lion are found in the landing area after the Mirror Wall. The entrance to the Palace area was through the mouth of the lion (Sinha Giri) and after climbing a staircase in the body of the lion, people had gone to the top of the rock climbing the steps cut into it. The remains of the Royal Palace, with two water tanks to collect water and the remains of the foundation of a small Dagoba (Stupa) are found on the summit, 600 feet above.`,
  },
  {
    id: 4,
    city: 'Polonnaruwa',
    country: 'Sri Lanka',
    image: polonnaruwa,
    rating: 4.5,
    heroImage: polonnaruwaBg,
    backgroundImage: polonnaruwaBg,
    hotels: [
      {
        name: 'Deer Park Hotel',
        image: DeerParkHotel,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Giritale Hotel',
        image: GiritaleHotel,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Hotel Suduar Aliya',
        image: HotelSuduarAliya,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Pharo Lake',
        image: PharoLake,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Ruins Chaaa',
        image: RuinsChaaa,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'The Lake Panorama Holiday Villa',
        image: TheLakePanoramaHolidayVilla,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
    ],
    description: `Sri Lanka’s splendid medieval capital was established as the first city of the land in the 11th Century, A.D. It replaced Anuradhapura, which was plundered, made desolate and laid hopelessly bare to the invading armies from South India.
    Three Kings dominate the chronicles of the city and the period. The city reached a dazzling but pitifully brief zenith in the 12th century and though ravaged by invasion in the centuries that followed, much evidence remains of the old grandeur and glory.The ruins of the ancient city stand on the east shore of a large artificial lake, the Topa Wewa Lake, or Parakrama Samudraya (the Sea of Parakrama), built by King Parakramabahu I (1153-86), whose reign was Polonnaruwa‘s golden age. Within a rectangle of city walls stand palace buildings and clusters of dozens of dagobas, temples and various other religious buildings.A scattering of other historic buildings can be found to the north of the main complex, outside the city walls and close to the main road to Habarana and Dambulla.
    To see many of the relics excavated from the site such as the stone lion which once guarded the palace of King Nissanka Malla, or the fine Hindu bronzes unearthed from the ruins of the Siva Devale Temple – you may have to visit the National Museum in Colombo, where they are kept. However, with the opening of the new Polonnaruwa Visitor Information Centre and its museum in 1998/9 some of the key exhibits were scheduled to return to the place where they were discovered.
    `,
  },
  {
    id: 5,
    city: 'Anuradhapura',
    country: 'Sri Lanka',
    image: anuradhapura,
    rating: 4.5,
    heroImage: anuradhapuraBg,
    backgroundImage: anuradhapuraBg,
    hotels: [
      {
        name: 'Aryana Hotel',
        image: aryanahotel,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Avasta Hotel',
        image: avasta,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Forest Rock Garden Resort',
        image: forestrockgardenresort,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Heritage Hotel',
        image: heritagehotel,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Randiya',
        image: randiya,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'White House',
        image: whitehouse,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
    ],
    description: `
    Anuradhapura was first settled by Anuradha, a follower of Prince Vijaya the founder of the Sinhala race. Later, it was made the Capital by King Pandukabhaya at about 380 B.C.According to the Mahavamsa, the epic of Sinhala History, King Pandukabhaya’s city was a model of planning. Precincts were set aside for huntsmen, for scavengers and for heretics as well as for foreigners. There were hostels and hospitals, at least one Jain chapel, and cemeteries for high and low castes. A water supply was assured by the construction of tanks, artificial reservoirs, of which the one named after the king itself exists to this day under the altered name of Baswakkulam.
    It was during the reign of King Devanampiya Tissa (250 – 210 B.C.) that the Arahat Mahinda, son of the great Buddhist Emperor Asoka, led a group of missionaries from North India to Sri Lanka. With his followers he settled in a hermitage of caves on the hill of Mihintale – the name which derives from Mahinda’s own.The new religion swept over the land in a wave. The King himself donated land for a great monastery in the very heart of the city which was also his own Royal Park – the beautiful Mahamegha Gardens.The Buddhist principality had had but a century to flourish when it was temporarily overthrown by an invader from the Chola Kingdom of South India. The religion, however, received no set-back. At this time far away on the southeast coast, was growing up the prince who was to become the paladin of Sinhala nationalism: Dutugamunu (161 – 137 B.C)
    For his entire martial prowess, King Dushta Gamini must have been a man of singular sensibility. He built the MIRISAVETI DAGOBA and the mighty Brazen Palace, which was nine stories high and presented to the Mahasanga (order of monks). But, the RUWANVELI DAGOBA, his most magnificent creation, he did not live to see its completion.
    Two more, at least, of the Anuradhapura Kings must be mentioned – if only because some of the greater monuments are indisputably attributable to them. The earlier of these was Vattagamani Abhaya (Valagamba) (103 & 89-77 B.C.) in the first year of whose reign Chola invaders again appeared and drove him temporarily into hiding. For fourteen years, while five Tamil Kings occupied his throne, he wandered often sheltering in jungle caves. It is recorded that as in his plight as he passed an ancient Jain hermitage, an ascetic, Gin called and taunted him. “The great black lion is fleeing!” Throughout his exile the gibe rankled. Winning the Kingdom back at last, he razed Giri’s hermitage to the ground, and built the ABHAYAGIRI Monastery. The name is a wry cant on his own name and the tactless hermit’s as well as (meaning mountain of fearlessness) a disclaimer of his cowardice! Next came the heretic king Mahasena (274 – 301 A.D) who built Sri Lanka’s largest Dagoba JETAWANARAMA (World Heritage Site), a much complicated irrigation system and 16 vast reservoirs (tank) like MINNERIYA, even today which irrigate thousands of acres of paddy land.
    Anuradhapura was to continue for six hundred years longer as the national capital. But as the protecting wilderness round it diminished with prosperity and internecine struggles for the royal succession grew, it became more and more vulnerable to the pressures of South Indian expansion; and the city was finally abandoned and the Capital withdrawn to more secluded fastnesses. But the monuments of its heyday survive, surrounded by such beauties as they become the past: the solemn umbrage of trees, the silence of cold stone, and the serenity of the sheltering sky.
    `,
  },
  {
    id: 6,
    city: 'Jaffna',
    country: 'Sri Lanka',
    image: jaffna,
    rating: 4.5,
    heroImage: jaffnadesti,
    backgroundImage: bg,
    hotels: [
      {
        name: 'Fox Resorts Jaffna',
        image: FoxResortsJaffna,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Jetwing Jaffna',
        image: JetwingJaffna,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Margosa Green',
        image: MargosaGreen,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'North Gate By Jetwing',
        image: NorthGatebyJetwing,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'The Thinnai',
        image: TheThinnai,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Tilko Jaffna City Hotel',
        image: TilkoJaffnaCityHotel,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
    ],
    description: `
    The transformation of Jaffna to a bustling teeming city and the reawakening of some of the country‘s oldest archeological treasures and natural beaches are a must see. The Jaffna Fort, Delft Island, Point Pedro Beach and its unique mouth watering cuisine are only a few reasons to travel North.
    A tour to Jaffna has become a definite stop and stay for most travelers seeking out something fresh, unspoiled and unseen. Vast and open landscapes combine with pristine beaches and ancient architecture. The busy Jaffna city market is not to be missed for the urban visitor looking for items which are only available in Jaffna from sweetmeats to woven handicraft to the unique spice mix that’s known to flavor Northern cuisine.
    Attractions in Jaffna include the Nallur Kovil it’s most famous landmark and tourist attraction the Kovil is at the heart of Jaffna and is easy to find. Timing is important to catch the interior of the Kovil’s architectural grandeur as it opens only during ceremonial offerings or ‘poojas’.
    There is also the Sri Nagapooshani Amman Temple on Nainativu island which is about three miles long and one mile across. It is about 25 miles south-west of Jaffna city. At Nainativu, the annual high festivals at the Hindu temple are conducted in the month of (June/July) for 16 days. The chariot festival which is celebrated on the 14th day attracts more than a hundred thousand pilgrims from all over the world.
    Nagadipe Purana Vihara is an island temple that can be reached via a boat ride and needs a full afternoon to see. One hour drive from Jaffna Town and a boat ride takes you to this island temple which becomes busy during festival time in July. It is also a location where you can visit three different places of worship at once, a Hindu Kovil, a Muslim Mosque and a Buddhist Temple all at once. The Jaffna Fort built by the Dutch suffered serious damage in the war but is being renovated and will be restored to its former glory for future visitors. 
    `,
  },
  {
    id: 7,
    city: 'Trincomalee',
    country: 'Sri Lanka',
    image: trincomalee,
    rating: 4.5,
    heroImage: trincomaleeBg,
    backgroundImage: trincomaleeBg3,
    hotels: [
      {
        name: 'Alfresco Beach Hotel',
        image: AlfrescoBeachHotel,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Amaranthe Bay Resort',
        image: AmarantheBayResort,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Jungle Bay Resort',
        image: JungleBayResort,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Sea Lotus Park Hotel',
        image: SeaLotusParkHotel,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Skandig Beach Resort',
        image: SkandigBeachResort,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Trinco Bluby Cinnamon',
        image: TrincoBlubyCinnamon,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
    ],
    description: `
    Legend, History and Nature all combine to make this sunny East Coast of Sri Lanka come alive for those who makes the effort to visit. Blessed with long white beaches, the best natural deep-water harbour, great cuisine, and the newest attraction of whale watching Trincomalee is a great place to escape and unwind.Located 257 kilometres from Colombo, Trincomalee could be reached easily through Anuradhapura or Habarana in the cultural triangle area. This is one of the most important cities in the east coast of Sri Lanka and is a great beach resort for the sun seeking tourist due to its hot and sunny climate throughout the year. Trincomalee is one of the largest and finest natural deep-water harbours in the world and is well connected by both rail and road.
    In the olden days Trincomalee was referred to as Gokanna and it has been an important sea port and a Buddhist Center. Historical records show that King Mahasen from the Anuradhapura period has built a Temple here called Gokanna Vihara during the 3rd Century. Trincomalee harbour has been an important strategic location for the sea traders since olden days and was first captured by the Portuguese, who destroyed the Hindu Temple on the Swami Rock and constructed a fort in 1624. The Dutch took over the harbour in 1639 and constructed Fort Fredrick in 1675, which was later taken over by the British in 1795 after defeating the Dutch. This was the first possession of the British in Sri Lanka. Fort Fredrick still stands in a well preserved condition and is still the center of administration in Trincomalee.
    Trincomalee is blessed with some of the best beaches in the island. This is a great beach destination for visitors to Sri Lanka, especially during the period from April till October, when the south and the west costs of the island are generally affected by the south-west monsoon. The beaches in Trincomalee and the stretch of beach from Uppuveli to Nillaveli, few kilometres north of Trinco are famous, white sandy beaches, great for swimming and snorkelling due to the shallow calm waters and the beautiful coral reefs. Pigeon Island is a small uninhabited island, less than 1km in to the sea from Nilaveli beach. A boat service is in operation to take visitors to this beautiful island, the home of the rare Blue Rock Pigeon. This is also an ideal place for swimming and snorkelling.
    Trincomalee is a great spot for whale and dolphin watching as many different species of whales and dolphins pass through the east coast along the Continental Shelf. Unlike at other hot spots for whale and dolphin watching in the island, here you get to see the animals very close to the shore due to the unusual positioning of the Continental Shelf where the whales and dolphins are found.
    This east coast destination is one of the finest places for deep sea fishing and scuba diving. As the Continental shelf is very close to Trincomalee large number of species of Game Fish, travel with the warm currents and are found beyond seven kilometres from the beach. This is also an excellent place for scuba divers/ under water photographers as the sea is uniformly calm and warm, thus the explorer gets a variety of visual delights.
    The Hot Water Springs in Kanniya, 8km from Trincomalee on the Anuradhapura road is another famous attraction in the area. Found here are seven very shallow wells of smaller sizes where the water temperatures of the wells are quite high and varies from each other. Local visitors bathe from all seven wells as they believe that the water contain therapeutic effects on the body.
    The Koneshwaram Hindu Shrine on the hillock inside the Fort is another place of interest in the heart of Trincomalee. The Vata-Da-Ge (circular relic house) in Thiriyaya, one of the best of the kind found in Sri Lanka, Velgam Vehera and the Seruwila Buddhist Temple with a beautiful Stupa are places of historical interest that could be visited from Trincomalee.`,
  },
  {
    id: 8,
    city: 'Kandy',
    country: 'Sri Lanka',
    image: kandy,
    rating: 4.5,
    heroImage: kandyBg1,
    backgroundImage: kandyBg,
    hotels: [
      {
        name: 'Amaara Sky Hotel Kandy',
        image: AmaaraSkyHotelKandy,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Cinnamon Citadel Kandy',
        image: CinnamonCitadelKandy,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Hotel Suisse',
        image: HotelSuisse,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Mahaweli Reach Hotel',
        image: MahaweliReachHotel,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Randholee Resort & Spa',
        image: RandholeeResortAndSpa,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'The Grand Kandyan Hotel',
        image: TheGrandKandyanHotel,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
    ],
    description: `The once impenetrable Kingdom of Kandy is home to the famous Temple of the Tooth and a lush 60-hectare Botanical garden. Full of ancient legends, cultural treasures and festivals Kandy can also be cozy and quiet. The drive offers stunning views of the hill country.

    A UNESCO World Heritage City, Kandy is the historic and romantic hill capital of Sri Lanka, situated 116 kilometres inland from Colombo. The road to Kandy is enchanting and exciting revealing the full glory of the tropics. The roads run round in sharp curves and looking down will offer a view of deep valleys, abysses, rocks, waterfalls and streams glittering in the sun and patterned in emerald with terraced rice fields. On the other side, the mountains rise majestically against the blue sky. Whether one looks up or down, it’s a sight of beauty, glorious beyond the power of words to explain. Margaret Mordecai, the author of the book ‘Indian Dreamlands’ described Kandy as ‘The Most beautiful Spot in the British Empire’. Nature has Indeed contributed towards it and so has the culture.
    
    Kandy was founded as the city of Royal Residence by King Vickramabahu in the late 14th Century and was the last strong hold of Sinhala rulers of the late medieval time until it came under British rule in 1815 when Sri Lanka became a full British colony. The last King of Sri Lanka and Kandy was King Sri Wickrama Rajasinghe, who ruled from 1798 – 1815 AD.
    
    Now transformed into a modern commercialised city as the capital of the Central Province with many monuments of the past, Kandy is now a thrilling mixture of new and old. The city holds a diversity of attractions with the preservation of certain important aspects of performing arts, religious practices of a bygone civilisation, and a dynamic new present with a tradition-bound past.
    
    The greatest attraction of the city is the Temple of the Sacred Tooth Relic of Buddha or Dalada Maligawa. It is one of the most sacred places for Buddhists all over the world. It is famous for its Sinhalese style architecture and is visited by thousands of devotees every day. Ancient cultural rituals and ceremonies started in the 4th Century are still being performed here daily with great devotion. Beating of drums, early in the morning and in the evening is one routine of this ritual experienced by many visitors to this sacred place.
    
    The well preserved buildings of the palace complex are living treasures and are presently being used for various different purposes. These historical buildings are preserved in the original form and could be visited by interested parties. The King’s Palace, Raja Wasala is presently used as the Museum of the Department of Archeology. The Council Chamber, popularly known as the Magul Maduwa is located to the left of the King’s Palace and is an excellent example of timber architecture of the Kandyan period. The Queens Bath, Ulpange, later converted to a library by the British, the King’s Harem, Palle Wasala presently the National Miseum of Kandy, the Queens’ Chambers, Meda Wasla and the Royal Armoury the former District Courts of Kandy are prominent historic buildings with great character.
    
    The many historic Buddhist Temples located in and around Kandy have also become famous attractions to both local and foreign visitors to Kandy. The famous temples, Gadaladeniya Vihare, Lankathilaka Vihare, Hindagala Vihare, Gangarama Vihare, Degaldoruwa Vihare and Embekke Devalaya have gained much importance and popularity due to their art work, architecture and the association they had with the Kandyan Kingdom.
    
    `,
  },
  {
    id: 9,
    city: 'Nuwara Eliya',
    country: 'Sri Lanka',
    image: nuwaraeliya,
    rating: 4.5,
    heroImage: nuwaraeliyaHero,
    backgroundImage: nuwaraeliyaBg,
    hotels: [
      {
        name: 'Amaya Langdale',
        image: AmayaLangdale,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Araliya Green Hills Hotel',
        image: AraliyaGreenHillsHotel,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Heritance Tea Factory',
        image: HeritanceTeaFactory,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Hill Pride City Hotel',
        image: HillPrideCityHotel,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
    ],
    description: `Sri Lanka is known for its tropical beaches, sun and the warm climate, but within a four hour drive from the Colombo airport lies Nuwara Eliya, the main city of the Hill Country at an elevation of 1990 meters from sea level. With a fresh and cool climate, sunny days, gentle breeze and the low-lying mist, Nuwara Eliya is also known as ‘Little England’ not only because of the similarities of the climate but also due to the many splendid colonial style buildings, which have left behind the charming Victorian architecture of the British.
    The area was discovered by the British, early in the 19th century and was transformed and developed in to a colonial city with roads connecting to other main cities and residential buildings built for the British rulers at the time. Nuwara Eliya soon became the home away from home for the British officials in Ceylon who wanted to escape to cooler climates. Most buildings in the city are characterized by the gabled roofs, stone walls and beautifully maintained flower gardens. The interior of the houses is unique unlike anywhere else in the island with log fire places, hunting memorabilia, wood paneling and timber floors.
    Nuwara Eliya is one of the most scenic cities in the island, surrounded by green mountains with several gorgeous cascading waterfalls. Most mountains are covered with tea plantations. Vegetables such as carrots, leeks, beetroot, radishes and spring onions are also cultivated on layered mountains enhancing the colourfulness and the beauty of Nuwara Eliya.
    Although most visitors to Sri Lanka don’t spend more than two nights in the hill county, there are many interesting activities and excursions to be experienced from Nuwara Eliya as listed below.
    Visit a Tea Factory and a plantation to experience the process of manufacturing Ceylon Tea, the best tea in the world Visit and walk the trails of Ella Gap and surrounding hill-country towns such as Bandarawela, Haputale, Diyatalawa and Hatton Visit Horton Plains National Park, World’s End and Baker’s Falls Play Golf at the beautiful 18 – hole golf course in the city built in 1891 Visit the Hakkgala Botanical Garden Boat riding at the Gregory Lake.
    Wonder around and experience the bird life at the Victoria Park located in the heart of the city Enjoy the beauty of many water falls such as Devon, St.Clair, Rawana Falls and many more.
    
    
    `,
  },
  {
    id: 10,
    city: 'Ella',
    country: 'Sri Lanka',
    image: ellaImage,
    rating: 4.5,
    heroImage: ellaBg,
    backgroundImage: ellaBg,
    hotels: [
      {
        name: '98 Acres Resortand Spa',
        image: AcresResortandSpa,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Chamodya Home Stay',
        image: ChamodyaHomeStay,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Ella Flower Garden Resort',
        image: EllFlowerGardenResort,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Hotel Onrock',
        image: HotelOnrock,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Lakshmis Hotel',
        image: LakshmisHotel,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'The Secret Ella',
        image: TheSecretElla,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
    ],
    description: `
    Ella is a small village in the highlands of Sri Lanka which is filled with tea estates, mountains, waterfalls and of course with some good air to breath.
    Lots of people make Ella as one of their must visit destination just to witness the breathtaking views it creates. It is a dream place for many trekkers with some of the best hikes the Island provides. This hidden village got vastly popular among the tourists lately.Views of mist and clouds covering the summits of the mountain range and the morning sun rise in Ella are spectacular scenes to witness and captured. After a fresh hike in the morning, hit a waterfall, grab some tasty Sri Lankan foods from somewhere with a beer, rest for a while and go for a railwalk to famous Nine Arch Bridge in the evening, you would sure love the all experience.
    Ella got its own historic values with the link to the Legendary Ravana stories too. You can explore all of them while you are here.
    Ella certainly a place with plenty of things to do which will keep you busy and happy.
    If you are looking for a place to unwind from your busy lifestyle and to spend some peaceful, relaxed time with the nature, this is the place and you will leave Ella with some fond memories to last a life time!
    `,
  },
  {
    id: 11,
    city: 'Yala',
    country: 'Sri Lanka',
    image: yala,
    rating: 4.5,
    heroImage: yalaHero,
    backgroundImage: yalaBg,
    hotels: [
      {
        name: 'Elephant Lake Yala',
        image: ElephantLakeYala,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Jetwing Yala',
        image: JetwingYala,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Laya Safari',
        image: LayaSafari,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Pardus Seek Luxury Tents',
        image: PardusSeekLuxuryTents,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Yala Leopard Lodge',
        image: YalaLeopardLodge,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Yala Wild Corridor Camp',
        image: YalaWildCorridorCamp,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
    ],
    description: `
    The second largest national park Yala is home to leopards, herds of elephant, deer and wild buffalo. Best visited during dry spells when animals throng to dwindling waterholes.
    Located in southeast Sri Lanka bordering the Indian Ocean, Yala National Park is approximately 305km from Colombo along the western and southern coastline. Yala can also be reached through Ratnapura and Embilipitiya, passing Udawalawa or via Ella and Wellawaya if travelling from the hill country. 
    Yala National Park was established in 1938 and is one of the two oldest parks in the country along with Wilpattu National Park, the largest national park in Sri Lanka. Yala is divided into 5 blocks and is approximately 125,000 hectares in extent including the strict nature reserve. Visitors can only visit Block 1, which has the highest density of large animals and birds. Yala is recognised as one of the best parks in the world to spot and photograph the leopard, having one of the highest leopard densities in the world. Famous for large herds of elephants as well as the occasional nasty lone elephant the park is also home to the sloth bear, spotted deer, sambhur, crocodiles, wild boar, wild buffalo and jackal.
    Small mammals such as the black naped hare, grey, ruddy & striped necked mongoose, grey langur & porcupine are common small mammals. Yala is one of the 70 Important Bird Areas (IBAs) in Sri Lanka with abundant bird life. Approximately 140 species have been recorded so far within the park. Changeable Hawk Eagle, Crested Serpent Eagle, Malabar Pied Hornbill, Jungle Fowl, Painted Stork, White Ibis and Black Necked Stork are commonly seen in Block 1.
    It is possible to take a full day jeep safari or to split the day into morning and afternoon safaris. The best chance to spot leopards and other big game is generally early in the morning and then again at dusk as the animals tend to avoid the hot sun and do not come out much during the day. There are 7 bungalows and a few camp sites inside the park. Visitors to the park could do standard or luxury camping inside the park with one of the experienced camping providers in the country.`,
  },
  {
    id: 12,
    city: 'Tangalle',
    country: 'Sri Lanka',
    image: tangalle,
    rating: 4.5,
    heroImage: tangalleHero,
    backgroundImage: tangalleBg,
    hotels: [
      {
        name: 'Anodawa Boutique Villa',
        image: AnodawaBoutiqueVilla,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Ananya Beach Resort',
        image: AnanyaBeachResort,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Buckingham Place',
        image: BuckinghamPlace,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Coco Tangalla',
        image: CocoTangalla,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Green Parrot Hotel',
        image: GreenParrotHotel,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Shangri Las Hambantota',
        image: ShangriLasHambantota,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
    ],
    description: `
     "One of the finest bays in Sri Lanka" R. L. Brohier: Seeing Ceylon (1965) "Beautiful Bay" Bella Wolf: How to see Ceylon (1914)
      Along the coast: Goyambokka Bay Beach, Pallikaduwa Bay Beach, Tangalle Bay, Tangalla Harbour, Medakettiya Beach, Medila Beach Just inland: Matara road, Tangalla Main road, Tangalla bridge over River Kirama, Hambantota road, Kalametiya Bird sanctuary, Rekawa Sea Turtle Nesting Beach
      The uncrowded small resort of Tangalla, 295km (122 miles) from Colombo, 48km (30km) east of Matara, & roughly midway along the south coast, is one of the most pleasant places in the region for a lazy beach holiday. If you wish a blast with watersports, shops, restaurants & nightlife, Tangalla isn't the place to come; Bentota Bay Beach Resort is. But if your are in search of great expanses of beautiful golden sandy beach to crash out on, you are on the right beach. Facing east, the small town centre straddles a freshwater lagoon where a small river flows into the sea, with a fishing harbour at its mouth. North of the harbour are villages of Medaketiya & Medilla, To the south, beyond a low headland, are villages of Goyambokka and Pallikaduwa.
      The Town Tangalle town itself is situated just back from a "projecting rock" from which, it is said, the towns name Tangalle is derived. The town, in spite of being beside the bay, fishing harbour & busy market has a relaxed atmosphere with some reminders of Dutch days, including the Rest House. It's one of the oldest rest houses in the Sri Lanka, originally built, as a plaque on the front steps indicates, by the Dutch in 1774. For its size, the town has a relaxed atmosphere with a busy market & many reminders of the Dutch heritage.
      The Beach Tangalle actually encompasses adjoining villages. To the west are the picturesque upmarket villages of Goyambokka & Pallikaduwa. And to the north, along the stretched arc of bay are Medaketiya and Medilla.`,
  },
  {
    id: 13,
    city: 'Galle',
    country: 'Sri Lanka',
    image: galle,
    rating: 4.5,
    heroImage: galleHero,
    backgroundImage: galleBg,
    hotels: [
      {
        name: 'Era Beach',
        image: EraBeach,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Ginganga Lodge',
        image: GingangaLodge,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Lady Hill',
        image: LadyHill,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Le Grand Galle',
        image: LeGrandGalle,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Niyagama House',
        image: NiyagamaHouse,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'The Heritage GalleFort',
        image: TheHeritageGalleFort,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
    ],
    description: `
    The seaside town of Galle is 116 km. from Colombo by road or rail, down the southwest coast. Both routes are very picturesque, following the coastline closely for much of the way. At some places you can still see the devastating effects of the Boxing Day Tsunami in 2004. Located near the southern end of the country, Galle enjoys a nice coast line and it’s a district that enjoys a great variance of settings, from beaches to marsh lands to dry planes to hills with tea and rubber plantations. The historical architecture of the city has also made it an important attraction to both local and international visitors. Galle has always been a famous port and one of the main natural harbours in Sri Lanka, until the British developed Colombo harbour and made Colombo the capital city.
    The modern history of Galle starts in 1505 AD with the arrival of Portuguese traders. However, Galle had been a prominent seaport long before western rule in the country. Persians, Arabs, Greeks, Romans, Malays, Indians, and Chinese were doing business through Galle port many years before the Portuguese arrived. The main trading goods from Sri Lanka has been Moon Stones & other gems, pearls, spices, elephants, ivory and scented wood. According to James Emerson Tennent, Galle was the ancient seaport of Tarshish, from which King Solomon drew ivory, peacocks and other valuables.
    Galle is the best example of a fortified city built by Europeans in south and southeast Asia, showing the interaction between European architectural styles and Sri Lankan traditions.The Dutch Fort built in the 17th Century still remains the main attraction in Galle and is the heart that pumps blood and has made Galle the living heritage city in Sri Lanka. The Dutch Fort has been declared a UNESCO World Heritage Site.
    The Portuguese, who came to Sri Lanka in 1505, established a fortress in Galle in 1589 A.D. In 1602 The Dutch landed in Batticoloa, attacked Galle in 1640 with an army of 2,000 men who came in 12 ships and captured it after 4 days of fierce fighting. The Dutch enlarged the Fort in 1663, with 11 Bastions including the Sun, Moon, Star, Zwart, Akesloot, Aurora, Aeloes, Neptune, Triton, Clippenburg and Point Utrecht. It is the largest fortified city built by the Dutch.
    The Fort build by the Dutch and later taken over by the British, still remains in a well preserved condition. Some of the oldest buildings such as The Dutch Church, which is the oldest Protestant Church in Sri Lanka, build in 1755 and the New Oriental Hotel Building the present Amangalla Hotel has given much character to the city. Still the streets inside the Fort remain narrow and many are known by their original names such as Leyn-Baan street, Zeeberg street and Moderabaay street. Characteristics of Dutch architecture could be clearly seen in the old houses inside the Fort, which are spacious and airy, with large ornamental doors and windows, pillared verandas and cool inner courtyards and gardens.
    Some old houses inside the fort have now been converted in to luxury and villas. Also the beautiful coastal areas of Ratgama, Galle, Unawatuna, Talpe, Habaraduwa and Ahangama are currently famous for the many beach villas and boutique hotels which have come up in the recent past, making Galle a famous destination for the leisure traveller seeking luxury and serenity on the beach. At present, Galle is also famous for the Galle Literary Festival held annually and the Galle International Cricket Stadium, where domestic and international cricket matches are played regularly.
    `,
  },
  {
    id: 14,
    city: 'Bentota',
    country: 'Sri Lanka',
    image: bentota,
    rating: 4.5,
    heroImage: bg2,
    backgroundImage: bentotaHero,
    hotels: [
      {
        name: 'Avani Bentota Resort',
        image: AvaniBentotaResort,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Nisala Arana Boutique Hotel',
        image: NisalaAranaBoutiqueHotel,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Saman Villas',
        image: SamanVillas,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Sri Villas',
        image: SriVillas,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Taj Bentota Resort & Spa',
        image: TajBentotaResortAndSpa,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Taru Villas Rock Villa',
        image: TaruVillasRockVilla,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
    ],
    description: `
    Bentota is located 64km south of Colombo in the South-western coastal belt of Sri Lanka. CMB Colombo Bandaranaike Airport at Katunayake – Negombo being 37km north of the city of Colombo, Bentota is approximately 101km south of the airport. City of Bentota, Sri Lanka.
    Bentota can be reached by the Colombo – Galle main road (A2) as well as the Colombo – Galle – Matara Southern Railway line. While the railway line from Negombo to Colombo mostly runs through inland, the continuation of the track from Colombo to Matara passing Bentota, hugs the southern coast most of the time enabling you to enjoy the pristine tropical beaches that pop up in between.
    Just across the Bentota Bridge over the River Bentara also called the ‘Bentota Ganga’ is the coastal town of Bentota. Bentota is a very pretty rural area: the greenery of the landscape needs a special mention. Most of the land is well shaded and sheltered by tall trees with coconut palm trees dominating the landscape. Bentota is famed as the prime beach resort of the south-western and southern coastal belts of Sri Lanka. South of the city of Colombo, the city of Kalutara with its fine beach is the gateway to south western and southern bay beaches. Kalutara is the next popular beach after Bentota. The Beruwala Bay Beach that is found just before reaching Aluthgama at the Bentota Bridge and Bentota Bay Beach just over the bridge are the most popular twin beaches along the coast. The coast towards the further South too is replete with lovely topical beaches making it ideal for a perfect beach holiday with the sun and sand.
    However, the Bentota Bay Beach, being encompassed within the Bentota National Holiday Resort Complex that features a fully-fledged support and serve infrastructure, is the most popular beach resort of Sri Lanka. With an array of luxury hotels, facilities and amenities for the foreign tourists, Bentota provides the perfect location for extended holidays by the beach. Furthermore, for the lovers of water sports, Bentota, in addition to its pristine palm fringed beaches, brings in more pleasures nowhere else to be found.
    Calm seas during the season from November to April make Bentota Beach ideal for snorkelling, diving, sailing, wind surfing, water-skiing and deep-sea fishing on a traditional outrigger canoe. Bentota enriched with safe swimming conditions in the season combined with fun water sports and exciting excursions that set up an ideal background for a relaxed holiday in Sri Lanka, is an attraction for families. Accommodation options at Bentota ranges from 5 star luxury resorts to midrange and budget properties. `,
  },
  {
    id: 15,
    city: 'Negambo',
    country: 'Sri Lanka',
    image: negambo,
    rating: 4.5,
    heroImage: negamboHero,
    backgroundImage: negamboBg,
    hotels: [
      {
        name: 'Camelot Beach Hotel',
        image: CamelotBeachHotel,
        rating: 4.5,
        url: 'http://maniumpathy.',
      },
      {
        name: 'Jetwing Lagoon',
        image: JetwingLagoon,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Terrace Green Hotel & Spa',
        image: TerraceGreenHotelAndSpa,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Tranquil Negombo Boutique',
        image: TranquilNegomboBoutique,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Villa Hundira',
        image: VillaHundira,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
      {
        name: 'Heritance Negombo',
        image: HeritanceNegombo,
        rating: 4.5,
        url: 'http://MarinoBeachColombo.',
      },
    ],
    description: `
    That doubles as a historical hotspot, Negombo is full of old world charm, folklore, fishing and friendly people. Once a great trading stop known for honey and spices Negombo is now better known for its fishing port and sunny beaches.
    Located approximately 37km north of the commercial capital of Colombo, the famous city of Negombo is only 7km away from the International Airport in Katunayake. Negombo was formally a small fishing village, now well known for its huge and old fishing industry with busy fish markets. The large fish market called the ‘Lellama’ located to the north of the town’s lagoon is the second largest fish market in the country, only second to the Colombo fish market. There are daily fish auctions, which give tourists a chance to meet the area’s fishermen and even organise fishing trips into the lagoon and the ocean beyond.
    Negombo is one of the most famous beach resorts in Sri Lanka with some of the finest sandy beaches on the west coast. Negombo offers a wide range of accommodation for tourists, ranging from home stays and guest houses to large luxury hotels with all modern facilities. This small vibrant tourist town is also famous for fine restaurants, a variety of pubs and a vibrant night life; there are also local handicrafts, batiks and jewellery boutiques on the beach and in the city for the eager shopper.
    Due to its close proximity to the International Airport, Negombo has become an important destination for spending the first and last couple of nights at the start or end of a tour. Also for the traveler without time to linger, Negombo is the best town to taste beach life and enjoy a few day excursions to some famous attractions in the country such as Kandy, Sigiriya, Dambulla etc.
    Negombo was a historic town with many legacies of its Portugese and Dutch settlers. Remains of its foreign rule include the Dutch fort built in 1672, as well as the centuries-old Portuguese and Dutch houses, administrative buildings, and churches. A majority of the community too are still Roman Catholics due to the influence of the Portuguese. The 100 km long canal network running through the city built by the Dutch for transportation purposes is still used, outrigger canoes and modern water-craft ply this route daily, for trade and tourist purposes. The shores of the canal are a habitat for rich birdlife and boat trips in the canals are a famous activity for tourists staying in the area.
    Some quiet stretches of the beach are maintained by tourist hotels, while others are always busy with fishermen and their equipment. Water-sports and diving are also popular among visitors, with a few well-preserved coral reefs and a 50-year-old shipwreck (Kudapaduwa) that serves as an artificial reef for many varieties of fish. The Muthurajawela marshland is one of the other attractions in the area, which is part of a 6,000-hectare (14,826-acre) protected marshland, home to over 190 species of wildlife. Many nature lovers and wildlife enthusiasts visit Muthurajawela to see and experience the rich biodiversity of the sanctuary.`,
  },
];
